module.exports = __webpack_public_path__ + "media/question8_au.1fbfba9b.mp3";